import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import {
  listProducts,
  Product,
  productReview,
  createReview,
  deleteProduct,
  createProduct,
  EditProduct,
} from './reducers/productReducers';
import {
  listShippings,
  shippingReducer,
  shipping,
  deleteShipping,
  createShipping,
  EditShipping,
} from './reducers/shippingReducers';
import {
  categoryCreateReducer,
  categoryDeleteReducer,
  categoryDetailsReducer,
 
  categoryListReducer,
  categoryUpdateReducer,
  productGetByCategoryReducer,
} from './reducers/categoryReducers'
import {
  userLogin,
  userRegister,
  userList,
  userDelete,
  userUpdate,
  getUser,
  forgotPassword,
  resetPassword,
} from './reducers/userReducers';
import { cartReducer } from './reducers/cartReducers';
import {
  createOrderReducer,
  getOrder,
  // orderPayReducer,
  orderApproveReducer,
  orderCancelReducer,
  orderPayReducer,
  orderDeliverReducer,
  authOrders,
  listOrders,
  deleteOrder,
} from './reducers/orderReducers';

const rootReducer = combineReducers({
  productList: listProducts,
  Product: Product,
  productReview: productReview,
  shippingList: listShippings,
  shipping: shipping,
  userLogin: userLogin,
  userRegister: userRegister,
  createReview: createReview,
  cart: cartReducer,
  shippingReducer: shippingReducer,
  createOrder: createOrderReducer,
  orderDetails: getOrder,
  orderApprove: orderApproveReducer,
  orderCancel: orderCancelReducer,
  orderPay: orderPayReducer,
  orderDeliver: orderDeliverReducer,
  authOrders: authOrders,
  orderList: listOrders,
  deleteOrder: deleteOrder,
  productGetByCategory: productGetByCategoryReducer,
  categoryCreate: categoryCreateReducer,
  categoryList: categoryListReducer,
  categoryDelete: categoryDeleteReducer,
  categoryDetails: categoryDetailsReducer,
  categoryUpdate: categoryUpdateReducer,
 
  deleteProduct: deleteProduct,
  createProductDetails: createProduct,
  updateProductDetails: EditProduct,
  deleteShipping: deleteShipping,
  createShippingDetails: createShipping,
  updateShippingDetails: EditShipping,
  userList: userList,
  userDeleteDetails: userDelete,
  userUpdateDetails: userUpdate,
  userDetails: getUser,
  forgotPasswordDetails: forgotPassword,
  resetPasswordDetails: resetPassword,
});

const cartItemsFromStorage = localStorage.getItem('cartItems') ? JSON.parse(localStorage.getItem('cartItems')) : [];

const shippingAddressFromStorage = localStorage.getItem('shippingAddress')
  ? JSON.parse(localStorage.getItem('shippingAddress'))
  : {};

  const notesFromStorage = localStorage.getItem('notes')
  ? JSON.parse(localStorage.getItem('notes'))
  : {};

  const cartAreasFromStorage = localStorage.getItem('cartAreas')
  ? JSON.parse(localStorage.getItem('cartAreas'))
  : {};

/* const paymentMethodAddressFromStorage = localStorage.getItem('paymentMethod')
  ? JSON.parse(localStorage.getItem('paymentMethod'))
  : ''; */

const userInfoFromStorage = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;

const initialState = {
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: shippingAddressFromStorage,
    cartAreas: cartAreasFromStorage,
    notes: notesFromStorage,
    
    // paymentMethod: paymentMethodAddressFromStorage,
  },
  shipping: {cartAreas: cartAreasFromStorage},
  userLogin: { userInfo: userInfoFromStorage },
};

const store = createStore(rootReducer, initialState, applyMiddleware(thunk));

export default store;
